import React, { useState, useEffect, useRef } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { LayoutContext } from "App/common/hoc/Layout";
import PaymentUI from "App/common/ui/PaymentUI";
import Loader from "App/common/ui/Loader";
import {
  updateCreditCardStart,
  fetchCCDetailsStart,
  applyPendingChargesStart
} from "store/actions";

function CCUpdateLayout(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);
  const [popLoader, setPopLoader] = useState(false);

  const [pendingChargersPopup] = useState(
    lState?.popup?.alertName === "applyPendingChargesActivate"
  );

  const [cardError, setCardError] = useState({
    card: { show: false, msg: "" },
    bill: { show: false, msg: "" },
    zip: { show: false, msg: "" }
  });

  const [newCard, sNewCard] = useState(false);

  const handleRef = useRef();

  const setNewCard = bool => {
    if (bool) {
      sNewCard(true);
      lMethods.updatePopupParams({
        backButton: () => {
          setNewCard(false);
          setCardError({
            card: { show: false, msg: "" },
            bill: { show: false, msg: "" },
            zip: { show: false, msg: "" }
          });
        }
      });
    } else {
      sNewCard(false);
      lMethods.updatePopupParams({
        backButton: false
      });
    }
  };

  useEffect(() => {
    if (props.ccDetails) setNewCard(false);
  }, [props.ccDetails]);

  useEffect(() => {
    props.fetchCCDetailsStart();
  }, []);

  useEffect(() => {
    if (props.notification.webActivity) lMethods.closePopup();
  }, [props.notification]);

  async function formSubmitHandler(e) {
    let details = {};
    let cardErr = false;

    await handleRef.current.handleSubmit(e).then(async res => {
      if (res.error && (newCard || props.ccDetails === undefined)) {
        setCardError(prevState => ({
          ...prevState,
          card: { show: true, msg: res.error.message }
        }));
        cardErr = true;
      } else if (res.bill.length < 1) {
        setCardError(prevState => ({
          ...prevState,
          bill: {
            show: true,
            msg: "Billing address cannot be blank"
          }
        }));
        cardErr = true;
      } else if (res.zip.length < 1) {
        setCardError(prevState => ({
          ...prevState,
          zip: { show: true, msg: "zip code cannot be blank" }
        }));
        cardErr = true;
      }
      if (!cardErr) {
        setCardError({
          card: { show: false, msg: "" },
          bill: { show: false, msg: "" },
          zip: { show: false, msg: "" }
        });
        cardErr = false;
        if (!newCard) {
          details.payment_info = {
            newcc: false,
            token: "",
            expiry: props.ccDetails.cardExp,
            last4Digit: props.ccDetails.cardNumber
          };
        } else {
          let payment_info = {
            expiry: res.token.card.exp_month + "/" + res.token.card.exp_year,
            last4Digit: res.token.card.last4,
            token: res.token.id,
            newcc: true
          };
          details.payment_info = payment_info;
        }
        details.zip = res.zip.trim();
        details.address = res.bill.trim();
      }
    });
    if (!cardErr) {
      if (pendingChargersPopup) {
        details.payment_info.plan_id = props.plan.id;
        props.applyPendingChargesStart(details);
      } else {
        props.updateCreditCardStart(details);
      }
      // lMethods.closePopup();
      setPopLoader(true);
    } else {
    }
  }

  return (
    <React.Fragment>
      {props.ccDetails && !popLoader ? (
        <React.Fragment>
          {/* <div className="popup_msg error" style={{display: 'none'}}><div className="message_content"><p>Make changes to save card details.</p><span className="close_icon"  /></div></div> */}
          <div className="field_wrap">
            <div className="cc_txt">
              {/* <p className="cc_para">
                Provide your credit card information for billing purposes.
                Prepaid cards will not be accepted
              </p> */}
            </div>
            <PaymentUI
              ref={handleRef}
              error={cardError}
              setCardError={setCardError}
              type="layout"
              ccDetails={props.ccDetails}
              setNewCard={setNewCard}
              newCard={newCard}
            />
          </div>
          <div className="popup_footer popup_footer_left">
            <div className="popup_footer_link">
              {" "}
              {!newCard && (
                <a
                  className="update_new_card"
                  onClick={() => {
                    setNewCard(true);
                    setCardError({
                      card: { show: false, msg: "" },
                      bill: { show: false, msg: "" },
                      zip: { show: false, msg: "" }
                    });
                  }}
                >
                  {" "}
                  Update new card{" "}
                </a>
              )}
            </div>
            <div className="popup_footer__btns button_inverse popup_footer__btns">
              <button
                className="btn blue btn_primary"
                onClick={e => formSubmitHandler(e)}
              >
                {pendingChargersPopup ? "Save & Reactivate" : "Save"}
              </button>
              {pendingChargersPopup ? (
                <button
                  className="btn btn_cancel"
                  onClick={() =>
                    lMethods.openPopup("applyPendingCharges", {
                      execute: () => {
                        lMethods.closePopup();
                      },
                      backButton: false
                    })
                  }
                >
                  Cancel
                </button>
              ) : (
                <button
                  className="btn btn_cancel"
                  onClick={() => lMethods.closePopup()}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </React.Fragment>
      ) : (
        <Loader />
      )}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    plan: state.account.plan,
    ccDetails: state.account.ccDetails,
    notification: state.common.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateCreditCardStart,
      fetchCCDetailsStart,
      applyPendingChargesStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CCUpdateLayout);
